import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Helmet } from 'react-helmet-async';

const VanPickup = () => {
  return (
    <>
      <Helmet>
        <title>How to Prepare for Your Van Rental Pickup</title>
        <meta
          name="description"
          content="Learn how to prepare for your van rental pickup with this step-by-step guide covering documents, inspection tips, and smooth handover."
        />
      </Helmet>
      <div className="bg-[#fff] w-full flex flex-col">
        <section
          className="hero--container relative flex flex-col justify-center w-full bg-no-repeat bg-cover bg-center pt-[65px] mt-[140px] md:h-[60vh]"
          style={{ backgroundImage: `url('../images/van-pickup.jpg')` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
          <div className="relative z-10">
            <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
              How to Prepare for Your Van Rental Pickup
            </h1>

            <div className="flex justify-center items-center gap-4 mt-10 md:text-sm text-xs mb-2">
              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faClock} className="w-4" />
                <p className="blog-publish-date">12/25/2025</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faComment} className="w-4" />
                <p className="blog-publish-date">5 Comments</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faBookmark} />
                <p className="blog-publish-date">1940 Views</p>
              </div>
            </div>
          </div>
        </section>

        <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
          <div className="mx-auto max-w-screen-md">
            <p className="pb-4 text-justify leading-7">
              Picking up a rental van for your event, business need, or group trip should be a smooth and simple process. At JJ Van Rental, we want your journey to start right—with confidence and zero confusion. Here’s a quick guide on how to prepare for your van rental pickup and make your experience hassle-free.
            </p>

            <p className="pb-4 text-justify leading-7">
              First, confirm all your booking details in advance. Double-check your pickup date, time, location, and van size. If you’ve arranged for airport, office, or home delivery, ensure someone is available to receive the vehicle and complete the paperwork.
            </p>

            <p className="pb-4 text-justify leading-7">
              Bring your identification documents. This typically includes a valid driver's license and the credit card used for booking. Some companies may also request proof of insurance or an additional form of ID, so it’s best to ask ahead of time.
            </p>

            <p className="pb-4 text-justify leading-7">
              Inspect the van before driving off. Check for any existing damage and make sure it’s recorded by the rental staff. This protects both you and the company from any misunderstandings later. Also, take a few moments to familiarize yourself with the van’s controls, especially if you're driving a larger model for the first time.
            </p>

            <p className="pb-4 text-justify leading-7">
              If you’re using the van for a long trip or special event, consider packing essentials in advance—water, snacks, phone chargers, and a list of any stops or delivery points. Planning your route ahead of time saves time and reduces stress.
            </p>

            <p className="pb-4 text-justify leading-7">
              At JJ Van Rental, our goal is to make your pickup process seamless. From clear communication to clean, road-ready vehicles, we’re committed to giving you a comfortable and reliable ride from the very first step. Be prepared, stay informed, and your rental pickup will be a breeze.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <div className="max-w-screen-md mx-auto rounded-md px-4 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
            {/* Tags */}
            <div className="flex flex-wrap gap-2">
              <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md text-sm">Van Rental</p>
              <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md text-sm">Pickup Guide</p>
              <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md text-sm">Group Travel</p>
            </div>

            {/* Social Buttons */}
            <div className="flex flex-wrap items-center gap-2">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#42599E] px-4 py-2 rounded-lg text-white text-sm"
              >
                <FontAwesomeIcon icon={faFacebook} /> Share
              </a>
              <a
                href="https://twitter.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#55ACEE] px-4 py-2 rounded-lg text-white text-sm"
              >
                <FontAwesomeIcon icon={faTwitter} /> Tweet
              </a>
              <a
                href="https://www.whatsapp.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#34AF23] px-4 py-2 rounded-lg text-white text-sm"
              >
                <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#0798CF] px-4 py-2 rounded-lg text-white text-sm"
              >
                <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
              </a>
            </div>
          </div>

        </section>
      </div>
    </>
  );
};

export default VanPickup;